<script setup lang="ts">
import BPLogoIcon from "@/assets/svg/bp-logo-white.svg?component";
import BPLogoSmall from "@/assets/img/bp-logo-small.png";
import IBGLogoIcon from "@/assets/svg/ibg-logo-white.svg?component";
import IBGLogoSmall from "@/assets/svg/ibg-logo-white-small.svg?component";
import { IS_BP_MANAGER, IS_IBG_MANAGER } from "@/consts";
import { computed } from "vue";
import { useNavigationStore } from "@/stores/navigation.module";

const navigationStore = useNavigationStore();
const isExpanded = computed(() => navigationStore.isNavExpanded);
</script>

<template>
  <div class="h-20 flex justify-center items-center">
    <RouterLink to="/" class="focus-visible-inverse rounded">
      <BPLogoIcon
        v-if="IS_BP_MANAGER && isExpanded"
        width="8.8125rem"
        height="1.5625rem"
      />
      <img
        v-if="IS_BP_MANAGER && !isExpanded"
        :src="BPLogoSmall"
        class="h-[1.875rem] w-[1.875rem]"
      />
      <IBGLogoIcon
        v-if="IS_IBG_MANAGER && isExpanded"
        width="8.125rem"
        height="2.125rem"
      />
      <IBGLogoSmall
        v-if="IS_IBG_MANAGER && !isExpanded"
        width="4.5rem"
        height="5rem"
      />
    </RouterLink>
  </div>
</template>
